import "./App.css";
import Weather from "./Weather";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Weather defaultCity="Tokyo" />
      </header>
      <footer>
        <a
          href="https://github.com/danpingw/react-weather-app"
          target="_blank"
          rel="noreferrer"
        >
          Open-source code
        </a>
        , by{" "}
        <a
          href="https://marvelous-haupia-3f9739.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          Zelda Wang
        </a>{" "}
        from Beijing
      </footer>
    </div>
  );
}

export default App;
